import React from 'react';

const Maintenance: React.FC = () => {
	return (
		<div style={{
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			height: '100vh',
			width: '100vw',
			backgroundColor: '#fff'
		}}>
			<img
				src="/maintenance.png"
				alt="Maintenance"
				style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
			/>
		</div>
	);
};

export default Maintenance;
